module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ("right:" + _vm.appRight + ""),
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "pc-nav"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showcomPc),
      expression: "showcomPc"
    }],
    staticClass: "app-ul"
  }, [_c('span', {
    staticClass: "logo",
    staticStyle: {
      "left": "-10px"
    }
  }), _c('span', {
    staticClass: "logoTangmama"
  }), _vm._v(" "), _c('span', {
    staticClass: "lis"
  }, [_c('li', {
    class: {
      'onThis1': _vm.onThisS === 1
    },
    staticStyle: {
      "margin-left": "450px"
    },
    on: {
      "click": function($event) {
        _vm.onThis(1)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "nav",
      "to": "/"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', {
    class: {
      'onThis1': _vm.onThisS === 2
    },
    on: {
      "click": function($event) {
        _vm.onThis(2)
      }
    }
  }, [_vm._v("客户端")]), _vm._v(" "), _c('li', {
    class: {
      'onThis1': _vm.onThisS === 7
    },
    on: {
      "click": function($event) {
        _vm.onThis(7)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "nav",
      "to": "/userInfo"
    }
  }, [_vm._v("糖糖圈会员")])], 1), _vm._v(" "), _c('li', {
    class: {
      'onThis1': _vm.onThisS === 3
    },
    on: {
      "click": function($event) {
        _vm.onThis(3)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "nav",
      "to": "/ClinicAppointment"
    }
  }, [_vm._v("诊所预约")])], 1), _vm._v(" "), _c('li', {
    class: {
      'onThis1': _vm.onThisS === 4
    },
    on: {
      "click": function($event) {
        _vm.onThis(4)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "nav",
      "to": "/content"
    }
  }, [_vm._v("控糖百科")])], 1), _vm._v(" "), _c('li', {
    class: {
      'onThis1': _vm.onThisS === 5
    },
    on: {
      "click": function($event) {
        _vm.onThis(5)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "nav",
      "to": "/sugarControl"
    }
  }, [_vm._v("数据上传")])], 1), _vm._v(" "), _c('li', {
    class: {
      'onThis1': _vm.onThisS === 6
    },
    on: {
      "click": function($event) {
        _vm.onThis(6)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "nav",
      "to": "/aboutUs"
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('a', {
    staticClass: "DL",
    staticStyle: {
      "margin-right": "0"
    },
    attrs: {
      "title": "医护登录",
      "target": "_blank",
      "href": "" + _vm.host + "/login.html"
    }
  }, [_vm._v("医护登录")]), _vm._v(" "), _c('a', {
    staticClass: "DL",
    staticStyle: {
      "margin-right": "25px"
    },
    attrs: {
      "title": "同伴社区",
      "target": "_blank",
      "href": "https://www.ttq.so/share"
    }
  }, [_vm._v("同伴社区")])])])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showcomHs),
      expression: "showcomHs"
    }],
    staticClass: "hs-nav"
  }, [_c('i', {
    staticClass: "hs-logo1"
  }), _vm._v(" "), _c('span', {
    staticClass: "hs-menu",
    on: {
      "click": _vm.menu
    }
  }, [_c('i', {
    staticClass: "menu-i"
  }), _c('i', {
    staticClass: "menu-i",
    staticStyle: {
      "margin": "10px 0"
    }
  }), _c('i', {
    staticClass: "menu-i"
  })])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slideShow),
      expression: "slideShow"
    }],
    staticClass: "slide-box",
    on: {
      "click": _vm.close,
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('section', {
    staticClass: "slides",
    style: ("right:" + _vm.slideRight + ""),
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "slideTitle"
  }, [_c('i', {
    staticClass: "logo3"
  }), _vm._v(" "), _c('label', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('ul', {
    staticClass: "slideUl"
  }, [_c('router-link', {
    attrs: {
      "to": "/Hello"
    }
  }, [_c('li', {
    on: {
      "click": _vm.routerLink
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://a.app.qq.com/o/simple.jsp?pkgname=so.ttq"
    }
  }, [_c('li', [_vm._v("糖糖圈客户端")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/article"
    }
  }, [_c('li', {
    on: {
      "click": _vm.routerLink
    }
  }, [_vm._v("控糖百科")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/aboutUsHs"
    }
  }, [_c('li', {
    on: {
      "click": _vm.routerLink
    }
  }, [_vm._v("关于我们")])])], 1)])]), _vm._v(" "), _c('router-view', {
    on: {
      "getMsgFormSon": function($event) {
        _vm.getMsgFormSon()
      }
    }
  }), _vm._v(" "), _c('client', {
    ref: "client"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5382b186","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 187
// module chunks = 1